import { Link } from "react-router";
import { FormProvider } from "react-hook-form";
import { Card } from "@/components/ui/card";
import { Input, Combobox, Textarea } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { CurrencyPoundIcon } from "@heroicons/react/24/outline";
import { CheckIcon, XMarkIcon } from "@heroicons/react/16/solid";

export const ServiceForm = ({
    methods,
    onSubmit,
    service,
    serviceTypes,
    isPending,
}) => {
    return (
        <div className="grid grid-cols-12 items-start">
            <div className="col-span-full grid grid-cols-subgrid gap-y-6">
                <Card size="lg" className="grid-cols-12 gap-y-6">
                    <FormProvider {...methods}>
                        <form
                            key={service?.serviceGuid ?? "new"}
                            onSubmit={methods.handleSubmit(onSubmit)}
                            className="col-span-full grid grid-cols-subgrid"
                        >
                            <div className="col-span-full grid grid-cols-subgrid md:col-span-3">
                                <div className="col-span-full">
                                    <h2 className="mb-3 text-xl font-semibold">
                                        Add service
                                    </h2>
                                </div>
                            </div>
                            <div className="col-span-full mb-6 grid grid-cols-subgrid gap-x-1 gap-y-6 md:col-span-8 md:gap-x-8 md:pl-4">
                                <div className="col-span-full md:col-span-4">
                                    <Input
                                        name="serviceTitle"
                                        label="Title"
                                        type="text"
                                    />
                                </div>
                                <div className="col-span-full md:col-span-4">
                                    <Textarea
                                        name="serviceDescription"
                                        label="Description"
                                        type="text"
                                        className="min-h-12"
                                    />
                                </div>
                                <div className="col-span-full md:col-span-4">
                                    <Combobox
                                        name="serviceTypes"
                                        label="Select services"
                                        placeholder="Select services"
                                        multiple
                                    >
                                        {serviceTypes?.map((d) => (
                                            <option
                                                key={d.typeGuid}
                                                value={d.typeGuid}
                                            >
                                                {d.title}
                                            </option>
                                        )) || null}
                                    </Combobox>
                                </div>
                                <div className="col-span-full md:col-span-4">
                                    <Input
                                        name="appointmentPrice"
                                        label="Appointment price"
                                        placeholder="0.00"
                                        type="number"
                                        step="0.01"
                                        defaultValue="0.00"
                                        icon={CurrencyPoundIcon}
                                    />
                                </div>
                                <div className="col-span-full md:col-start-1 md:col-end-5">
                                    <Input
                                        name="appointmentLength"
                                        label="Appointment length"
                                        placeholder="Appointment length"
                                        type="time"
                                        defaultValue="00:00"
                                    />
                                </div>
                                <div className="col-span-full md:col-span-4">
                                    <Input
                                        name="turnaroundLength"
                                        label="Turnaround length"
                                        placeholder="Turnaround length"
                                        type="time"
                                        defaultValue="00:00"
                                    />
                                </div>
                                <div className="col-span-full mt-10 flex gap-2">
                                    <Button
                                        type="submit"
                                        variant="primary"
                                        disabled={isPending}
                                    >
                                        <CheckIcon className="stroke-2" />
                                        Save
                                    </Button>
                                    <Button
                                        variant="secondary"
                                        asChild
                                        disabled={isPending}
                                    >
                                        <Link to="/clinician/services">
                                            <XMarkIcon className="stroke-2" />
                                            Cancel
                                        </Link>
                                    </Button>
                                </div>
                            </div>
                        </form>
                    </FormProvider>
                </Card>
            </div>
        </div>
    );
};
